var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0a18 18 0 1 0 18 18A18.053 18.053 0 0 0 18 0z",
    fill: "#00c4ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.686 29.494a2.7 2.7 0 0 0 2.686-2.717c0-1.5-2.686-5.341-2.686-5.341S15 25.276 15 26.777a2.7 2.7 0 0 0 2.686 2.717m1.2-3.6a.7.7 0 1 1-.69.7.694.694 0 0 1 .69-.7",
    transform: "translate(.314 2.667)",
    fill: "#f5f5f5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.515 0h-18v3.122l6.706 7.067v7.676l4.567-3.126v-4.624L25.51 3.1h.005zM17.93 14.254l-2.85 1.951V10.5h2.85zm.222-4.742h-3.363L8.706 3.1H24.3zm6.507-7.3H8.35V.9h16.309z",
    transform: "translate(1.485 5.34)",
    fill: "#f5f5f5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterFilter);
export default __webpack_public_path__ + "static/media/water-filter.19a3000cf225095f1785f84cf23c628f.svg";
export { ForwardRef as ReactComponent };